import React from "react";
import { connect } from "react-redux";
import { Button, Popover, List, Tooltip } from "devextreme-react";
import helper from "../../helpers/validaciones";

class InfoUsuario extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showBtnApp: false,
    };
  }
  showHidePopover = (open) => {
    if (this.props.isTourOpen) return;
    if (open) {
      this.props.handleOpen();
    } else {
      this.props.handleClose();
    }
  }

  handleLogout = () => {
    this.showHidePopover(false);
    this.props.logoutCallback();
  }

  goMyAccount = () => {
    this.showHidePopover(false);
    this.props.myAccountCallback();
  }

  handleShowTooltip = () => {
    this.setState({ showBtnApp: true });
  }
  handleHideTooltip = () => {
    this.setState({ showBtnApp: false });
  }
  render() {
    const {
      userData,
    } = this.props;

    return (
      <div>
        <div onMouseOver={this.handleShowTooltip} onMouseLeave={this.handleHideTooltip}>
          <Button
            id="btnUserInfo"
            onClick={() => this.showHidePopover(!this.props.isOpen)}
            stylingMode="text"
            className="buttonIconTopBar"
            type="normal"
          >
            <div className="cardCircleSesion">
              <div className="cardTextCircleSesion">
                {`${helper.getFirstLetter(userData.FirstName)}${helper.getFirstLetter(userData.LastName)}`}
              </div>
            </div>
          </Button>
          {
            this.props.openPopOver === false && this.props.isOpenAppStack === false && this.props.isOpen === false && this.state.showBtnApp &&
            <Tooltip
              visible={this.props.openPopOver === false && this.props.isOpenAppStack === false && this.props.isOpen === false && this.state.showBtnApp}
              style={{ marginTop: "20px" }}
              contentRender={() => (
                <div>
                  Cerrar sesión
                </div>
              )}
              position="top"
              target="#btnUserInfo"
            />
          }
        </div>
        <Popover
          target="#btnUserInfo"
          position="bottom"
          className="info-usuario-popup"
          visible={this.props.isOpen}
          closeOnOutsideClick={!this.props.isTourOpen}
          onHiding={() => this.showHidePopover(false)}
        >
          <React.Fragment>
            <div className="row zero" id="tour_account_info">
              <div className="col-12">
                <div className="cardCircle">
                  <div className="cardTextCircle">
                    {`${helper.getFirstLetter(userData.FirstName)}${helper.getFirstLetter(userData.LastName)}`}
                  </div>
                </div>
              </div>
              <div className="col-12 datosCuenta">
                <div className="col-12 nameCard" >
                  <h5>
                    {`${userData.FirstName} ${userData.LastName !== "undefined" ? userData.LastName : ""}`}
                  </h5>
                </div>
                <div className="col-12 mailCard">
                  <h5>
                    {userData.Email}
                  </h5>
                </div>
              </div>
              <div className="col-12 divider">
              </div>
            </div>

            <List
              className="app-info-list"
              selectionMode="none"
              items={[
                // { name: "Mi Cuenta", icon: "H", onClick: this.goMyAccount },
                {
                  name: "Cerrar sesión", icon: "r", onClick: this.handleLogout, tourId: "tour_cerrar_sesion",
                },
              ]}
              itemComponent={(props) => (
                <div className="app-info-item" id={props.tourId}>
                  <i className="achs-icon" > {props.icon}</i>
                  <span>{props.name}</span>
                </div>
              )}
            />
          </React.Fragment>
        </Popover>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  openPopOver: state.headerNotificaciones.openPopOver,
  isOpenAppStack: state.header.isOpenAppStack,

});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoUsuario);

